const disabledFields = [
  'S4_STORE'
]

export default disabledFields
